import { render, staticRenderFns } from "./ServiceIntro.vue?vue&type=template&id=b859bf76&scoped=true"
import script from "./ServiceIntro.vue?vue&type=script&lang=js"
export * from "./ServiceIntro.vue?vue&type=script&lang=js"
import style0 from "./ServiceIntro.vue?vue&type=style&index=0&id=b859bf76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b859bf76",
  null
  
)

export default component.exports